import { FormComponentProps } from 'antd/lib/form'
import Raven from 'raven-js'
import * as React from 'react'
import styled from 'styled-components'
import Button from 'web-makeup/dist/Button'
import Form from 'web-makeup/dist/Form'
import H5 from 'web-makeup/dist/H5'
import Input from 'web-makeup/dist/Input'
import Notification from 'web-makeup/dist/Notification'

import { GetProducerProfile } from '../../typings/types'

import RequestTypes from './../RequestTypes'
import ServiceQualityLevels from './../ServiceQualityLevels'

const SubmitButton = styled(Button as any)`
  &&& {
    width: 100%;
    height: 3rem;
  }

  > i {
    margin-right: 0.5rem;
  }
`

export const handleSubmit = (onSubmit, validateFields) => (
  event: React.FormEvent<HTMLFormElement>
) => {
  event.preventDefault()
  validateFields(async (err, values) => {
    if (err) {
      return
    }

    try {
      await onSubmit(values)

      Notification.success({
        message: 'Successfully updated',
        description: 'The producer has been successfully activated/updated',
      })
    } catch (error) {
      Raven.captureException(error)

      Notification.error({
        message: 'Error updating profile',
        description: 'The profile has not been updated',
      })
    }
  })
}

type Props = {
  onSubmit: (values) => void
  loading: boolean
  data: GetProducerProfile.Query
} & FormComponentProps

export const ProducerAbilitiesForm: React.SFC<Props> = ({
  onSubmit,
  loading,
  data,
  form: { getFieldDecorator, validateFields },
}: Props) => (
  <Form onSubmit={handleSubmit(onSubmit, validateFields)}>
    <H5>Service Quality Level</H5>
    <Form.Item>
      {getFieldDecorator('producerProfile.serviceQualityLevelSlug', {
        initialValue:
          data &&
          data.getProducerProfile &&
          data.getProducerProfile.serviceQualityLevel &&
          data.getProducerProfile.serviceQualityLevel.slug,
      })(<ServiceQualityLevels />)}
    </Form.Item>

    <H5>Request Types</H5>
    <Form.Item>
      {getFieldDecorator('producerProfile.requestTicketTypeUuids', {
        initialValue:
          data &&
          data.getProducerProfile &&
          data.getProducerProfile.requestTicketTypes &&
          data.getProducerProfile.requestTicketTypes.map(type => type.uuid),
      })(<RequestTypes />)}
    </Form.Item>

    {getFieldDecorator('userUuid', {
      initialValue: data && data.getProducerProfile && data.getProducerProfile.user.uuid,
    })(<Input type="hidden" />)}

    {data &&
      data.getProducerProfile &&
      !data.getProducerProfile.activated &&
      getFieldDecorator('producerProfile.activated', {
        initialValue: true,
      })(<Input type="hidden" />)}

    <SubmitButton
      type="primary"
      size="large"
      data-qa={
        data && data.getProducerProfile && data.getProducerProfile.activated
          ? 'update-cta'
          : 'activate-cta'
      }
      htmlType="submit"
      loading={loading}
    >
      {data && data.getProducerProfile && data.getProducerProfile.activated ? 'Update' : 'Activate'}
    </SubmitButton>
  </Form>
)

export default Form.create()(ProducerAbilitiesForm)



// WEBPACK FOOTER //
// ./src/components/ProducerAbilitiesForm/ProducerAbilitiesForm.tsx